export default "__VITE_ASSET__C8ooJ36G__"